/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_AR_EG: Record<string, string> = {
    ariaAnnounceChart: 'مخطط، ${seriesCount}[number] سلسلة',
    ariaAnnounceFlowProportionLink: 'رابط ${index} من ${count}، من ${from} إلى ${to}، ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'العقدة ${index} من ${count}, ${description}',
    ariaAnnounceGaugeChart: 'مخطط المقياس، ${caption}',
    ariaAnnounceHierarchyChart: 'مخطط هرمي، ${caption}',
    ariaAnnounceHierarchyDatum: 'المستوى ${level}[number]، ${count}[number] أطفال، ${description}',
    ariaAnnounceHoverDatum: '${datum} الموجود على',
    ariaDescriptionLegendItem: 'اضغط على المسافة أو الإدخال للتبديل بين الرؤية',
    ariaLabelAddHorizontalLine: 'إضافة خط أفقي',
    ariaLabelAnnotationOptionsToolbar: 'خيارات التعليق',
    ariaLabelAnnotationSettingsDialog: 'إعدادات التعليق التوضيحي',
    ariaLabelColorPicker: 'منتقي الألوان',
    ariaLabelFinancialCharts: 'الرسوم البيانية المالية',
    ariaLabelLegend: 'الأسطورة',
    ariaLabelLegendItem: '${label}، عنصر العنوان التفسيري رقم ${index}[number] من ${count}[number]',
    ariaLabelLegendItemUnknown: 'عنصر غير معروف في الأسطورة',
    ariaLabelLegendPageNext: 'صفحة الرموز التوضيحية التالية',
    ariaLabelLegendPagePrevious: 'صفحة الأسطورة السابقة',
    ariaLabelLegendPagination: 'تكرار الأسطورة',
    ariaLabelNavigator: 'المُتَنَقِّل',
    ariaLabelNavigatorMaximum: 'الحد الأقصى',
    ariaLabelNavigatorMinimum: 'الحد الأدنى',
    ariaLabelNavigatorRange: 'المدى',
    ariaLabelRangesToolbar: 'النطاقات',
    ariaLabelSettingsTabBar: 'الإعدادات',
    ariaLabelZoomToolbar: 'تكبير',
    ariaValuePanRange: '${min}[percent0to2dp] إلى ${max}[percent0to2dp]',
    contextMenuDownload: 'تنزيل',
    contextMenuPanToCursor: 'تحريك إلى هنا',
    contextMenuToggleOtherSeries: 'تبديل السلاسل الأخرى',
    contextMenuToggleSeriesVisibility: 'تبديل الرؤية',
    contextMenuZoomToCursor: 'التكبير إلى هنا',
    dialogHeaderChannel: 'القناة',
    dialogHeaderDatePriceRange: 'التاريخ والسعر',
    dialogHeaderDateRange: 'النطاق الزمني',
    dialogHeaderFibonacciRange: 'إعادة تصحيح فيبوناتشي',
    dialogHeaderLine: '‘خط’',
    dialogHeaderPriceRange: 'نطاق السعر',
    dialogHeaderText: 'نص',
    dialogInputAlign: 'توجيه',
    dialogInputColorPicker: 'اللون',
    dialogInputColorPickerAltText: 'لون النص',
    dialogInputExtendAbove: 'تمديد إلى الأعلى',
    dialogInputExtendBelow: 'مد التمديد للأسفل',
    dialogInputExtendChannelEnd: 'تمديد نهاية القناة',
    dialogInputExtendChannelStart: 'تمديد بداية القناة',
    dialogInputExtendLeft: 'تمديد إلى اليسار',
    dialogInputExtendLineEnd: 'Extend line end',
    dialogInputExtendLineStart: 'تمديد بداية الخط',
    dialogInputExtendRight: 'توسيع لليمين',
    dialogInputFibonacciBands: 'الأشرطة',
    dialogInputFibonacciBandsAltText: 'أشرطة فيبوناتشي',
    dialogInputFillColorPicker: 'تعبئة',
    dialogInputFillColorPickerAltText: 'لون التعبئة',
    dialogInputFontSize: 'حجم',
    dialogInputFontSizeAltText: 'حجم الخط',
    dialogInputLineStyle: 'شرطة',
    dialogInputPosition: 'الموضع',
    dialogInputReverse: 'عكس',
    dialogInputShowFill: 'إظهار الملء',
    dialogInputStrokeWidth: 'وَزن',
    dialogInputStrokeWidthAltText: 'وَزن الخط',
    iconAltTextAlignCenter: 'مركز',
    iconAltTextAlignLeft: 'يسار',
    iconAltTextAlignRight: 'يمين',
    iconAltTextClose: 'إغلاق',
    iconAltTextLineStyleDashed: 'المتقطع الطويل',
    iconAltTextLineStyleDotted: 'مُخطط متقطع',
    iconAltTextLineStyleSolid: 'صلب',
    iconAltTextPositionBottom: 'الأسفل',
    iconAltTextPositionCenter: 'مركز',
    iconAltTextPositionTop: 'أعلى',
    inputTextareaPlaceholder: 'أضف نص',
    measurerDateRangeBars: '${value}[number] أشرطة',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'الحجم ${value}',
    overlayLoadingData: 'جارٍ تحميل البيانات...',
    overlayNoData: 'لا توجد بيانات لعرضها',
    overlayNoVisibleSeries: 'لا توجد سلسلة مرئية',
    overlayUnsupportedBrowser: 'إصدار المتصفح غير متوافق. يرجى ترقية المتصفح.',
    seriesHistogramTooltipCount: '${yName} (العدد)',
    seriesHistogramTooltipFrequency: 'التكرار',
    seriesHistogramTooltipMean: '${yName} (المتوسط)',
    seriesHistogramTooltipSum: '${yName} (المجموع)',
    toolbarAnnotationsArrow: 'سهم',
    toolbarAnnotationsArrowDown: 'سهم لأسفل',
    toolbarAnnotationsArrowUp: 'سهم لأعلى',
    toolbarAnnotationsCallout: 'تعليق',
    toolbarAnnotationsClearAll: 'امسح الكل',
    toolbarAnnotationsComment: 'تعليق',
    toolbarAnnotationsDatePriceRange: 'التاريخ والسعر',
    toolbarAnnotationsDateRange: 'نطاق التاريخ',
    toolbarAnnotationsDelete: 'حذف',
    toolbarAnnotationsDisjointChannel: 'قناة منفصلة',
    toolbarAnnotationsDragHandle: 'سحب شريط الأدوات',
    toolbarAnnotationsFibonacciAnnotations: 'فيبوناتشي',
    toolbarAnnotationsFibonacciRetracement: 'ارتداد فيب',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'الفيبوناتشي المستند إلى الاتجاه',
    toolbarAnnotationsFillColor: 'لون التعبئة',
    toolbarAnnotationsHorizontalLine: 'خط أفقي',
    toolbarAnnotationsLineAnnotations: 'خطوط الاتجاه',
    toolbarAnnotationsLineColor: 'لون الخط',
    toolbarAnnotationsLineStrokeWidth: 'عرض خط الرسم',
    toolbarAnnotationsLineStyle: 'نوع الخط',
    toolbarAnnotationsLock: 'قفل',
    toolbarAnnotationsMeasurerAnnotations: 'القياسات',
    toolbarAnnotationsNote: 'ملاحظة',
    toolbarAnnotationsParallelChannel: 'قناة متوازية',
    toolbarAnnotationsPriceRange: 'نطاق السعر',
    toolbarAnnotationsQuickDatePriceRange: 'قياس',
    toolbarAnnotationsSettings: 'الإعدادات',
    toolbarAnnotationsShapeAnnotations: 'الأسهم',
    toolbarAnnotationsText: 'نص',
    toolbarAnnotationsTextAnnotations: 'الكتابات التوضيحية',
    toolbarAnnotationsTextColor: 'لون النص',
    toolbarAnnotationsTextSize: 'حجم النص',
    toolbarAnnotationsTrendLine: 'خط الاتجاه',
    toolbarAnnotationsUnlock: 'افتح القفل',
    toolbarAnnotationsVerticalLine: 'الخط العمودي',
    toolbarRange1Month: '1ش',
    toolbarRange1MonthAria: 'شهر واحد',
    toolbarRange1Year: 'سنة',
    toolbarRange1YearAria: 'سنة واحدة',
    toolbarRange3Months: '٣ شهور',
    toolbarRange3MonthsAria: '٣ شهور',
    toolbarRange6Months: '٦ش',
    toolbarRange6MonthsAria: '٦ شهور',
    toolbarRangeAll: 'الكل',
    toolbarRangeAllAria: 'الكل',
    toolbarRangeYearToDate: 'السنة حتى تاريخه',
    toolbarRangeYearToDateAria: 'منذ بداية السنة',
    toolbarSeriesTypeCandles: 'الشموع',
    toolbarSeriesTypeDropdown: 'نوع الرسم البياني',
    toolbarSeriesTypeHighLow: 'مرتفع منخفض',
    toolbarSeriesTypeHLC: 'إتش إل سي',
    toolbarSeriesTypeHollowCandles: 'الشموع المجوفة',
    toolbarSeriesTypeLine: 'خط',
    toolbarSeriesTypeLineWithMarkers: 'خط مع علامات',
    toolbarSeriesTypeOHLC: 'أو إتش إل سي',
    toolbarSeriesTypeStepLine: 'خطوة السطر',
    toolbarZoomPanEnd: 'التجول إلى النهاية',
    toolbarZoomPanLeft: 'تحريك لليسار',
    toolbarZoomPanRight: 'تحريك لليمين',
    toolbarZoomPanStart: 'التحريك إلى البداية',
    toolbarZoomReset: 'إعادة تعيين التكبير',
    toolbarZoomZoomIn: 'تكبير',
    toolbarZoomZoomOut: 'تصغير',
    tooltipPaginationStatus: '${index}[number] من ${count}[number]',
};
